var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpperBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 440,
    height: 291,
    viewBox: "0 0 440 291",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V291C4.46851 289.172 10.1295 287.274 16.3406 285.191C34.4684 279.114 57.2821 271.465 68.8107 259.393C77.1844 250.625 81.4136 241.303 85.4791 232.342C91.5992 218.852 97.3486 206.179 116.307 197.443C132.318 190.065 144.181 189.036 155.469 188.056C166.426 187.105 176.841 186.202 189.985 179.585C212.953 168.024 219.633 151.311 226.399 134.384C227.494 131.644 228.592 128.899 229.761 126.17C238.152 106.573 249.733 90.9279 278.767 78.4431C295.25 71.3557 309.245 72.3151 322.532 73.2261C332.651 73.9198 342.36 74.5854 352.445 71.6476C375.774 64.8521 390.879 49.9969 400.781 35.7738C409.637 23.0521 424.972 5.76887 440 0H0Z",
    fill: "url(#paint0_linear_2717_330)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2717_330",
    x1: 220.239,
    y1: 4.50902,
    x2: 220.239,
    y2: 291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A4050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#465282"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpperBackground);
export default __webpack_public_path__ + "static/media/upperBackground.e1da2b8553039b3e26ac04c4355c73b2.svg";
export { ForwardRef as ReactComponent };